import React from 'react';
// import { withCookies } from 'react-cookie';
import { connect } from 'react-redux'
import { redirectTo } from './../../action/redirection'
import * as productsAction from './../../action/productsAction';
import ProductsList from './productsList'
import AccessoriesHeader from '../header/accessoriesHeader';
import Faq from '../faq/index';
import Compatibility from './filter/compatibility';
import Brand from './filter/brand';
import Color from './filter/color';
import { Utils } from '../../util/utils';
import Loader from './../../components/loader';
import { withRouter } from "react-router";
import { updateSCTags } from './../../service/dtmTag';
import { updatePageLogs, checktime, catchJSException } from './../../service/logService';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import {mvaNavigationPattern } from '../../constants/actionType'
// import { withCookies } from 'react-cookie';
import { Helmet } from "react-helmet";

export class Product extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);

        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.state = {
            showCompatibility: true,
            showBrand: true,
            showColor: true,
            width: '250px', display: 'none',
            popupVisible: false,
            sortBy: 'Featured',
            categoryStoreValue: [],
            filterCondition: {
              categoryId:this.props.productsState.pageinfo == null ?
                this.props.categoriesState.categoryDetails.categoryName.categoryId.toString() : this.props.productsState.pageinfo.categoryId,
                color: [],
                brand: [],
                compatibility: [],
                price: ''

            },
            paginationState: {},
            currentPage: 1,
            filterTag: "Show filter",
            filterFlag: false,
            signIn: false,
            clrFlag:true
        }
    }
    OnProductItemClick = ((selectedprds) => {
        try {
            let redirectURL = window.location.pathname + '/' + selectedprds
            redirectTo(redirectURL, this.props.dispatch)
        } catch (ex) {
            catchJSException('product_index', this.props.appState.visitId, 'OnProductItemClick', ex);
        }
    })
    onFilterEvent = (category, value,id) => {
        try {
            let filterCondition = this.props.filterDataValue
            if (category === 'price')
                filterCondition[category] = value

            else {
                const valueIndex = filterCondition[category].indexOf(value)
                if (valueIndex === -1)
                    filterCondition[category].push(value)
                else {
                    filterCondition[category] = filterCondition[category].filter(popValue => popValue !== value)
                }
            }
            let request = filterCondition
            request['signedIn'] = this.props.categoriesState.isValidUser;
            request['mlpFlow'] = (this.props.appState && this.props.appState.mlpFlow) ? this.props.appState.mlpFlow : false;
            request['redemptionProductName'] = (this.props.appState && this.props.appState.mlpPDP) ? this.props.appState.mlpPDP : "";
            productsAction.setFilterData(this.props.dispatch, request)
            
                this.setState({
                    filterFlag: false,
                    filterTag: "Show filter ",
                    showCompatibility: true,
                    showBrand: true,
                    showColor: true
                 })
            productsAction.getProductsFromApi(JSON.stringify(request), this.props.dispatch, this.props.appState.visitId,id)
        } catch (ex) {
            catchJSException('product_index', this.props.appState.visitId, 'onFilterEvent', ex);
        }
    }

    onSearchValue = (category, selectedProd) => {
        if (this.props.filterDataValue != null) {
            let selectedFilterValue = this.props.filterDataValue[category]
            let checkedValue = selectedFilterValue.includes(selectedProd)
            return checkedValue
        }
    }

    getProducts() {
        // console.log('data',this.props.categoriesState.categoryDetails.categoryName)
        // if (this.props.categoriesState.categoryDetails.categoryName!==null) {
        //     this.setState({
        //         categoryStoreValue:this.props.categoriesState.categoryDetails.categoryName
        //     })}
        let request
        if (this.props.filterDataValue === undefined || this.props.filterDataValue === null) {
            request = this.state.filterCondition
            request['signedIn'] = this.props.categoriesState.isValidUser;
            request['mlpFlow'] = (this.props.appState && this.props.appState.mlpFlow) ? this.props.appState.mlpFlow : false;
            request['redemptionProductName'] = (this.props.appState && this.props.appState.mlpPDP) ? this.props.appState.mlpPDP : "";
            productsAction.setFilterData(this.props.dispatch, request)
            productsAction.getProductsFromApi(JSON.stringify(request), this.props.dispatch, this.props.appState.visitId)
        }

        else {
           request = this.state.filterCondition
           // request = this.props.filterDataValue
            request['categoryId'] = this.props.productsState.pageinfo.categoryId
            // request['signedIn'] = this.state.signIn
            request['signedIn'] = this.props.categoriesState.isValidUser;
            request['mlpFlow'] = (this.props.appState && this.props.appState.mlpFlow) ? this.props.appState.mlpFlow : false;
            request['redemptionProductName'] = (this.props.appState && this.props.appState.mlpPDP) ? this.props.appState.mlpPDP : "";
            productsAction.setFilterData(this.props.dispatch, request)
            productsAction.getProductsFromApi(JSON.stringify(request), this.props.dispatch, this.props.appState.visitId)
            //logic to expand
            request.brand.length !== 0 && this.showBrandProduct()
            request.compatibility.length !== 0 && this.showCompatibilityProduct()
            request.color.length !== 0 && this.showColorProduct()
        }
        this.processPageAfterVisitID()
    }
    componentWillMount(){
        // this.props.dispatch({ type: 'PRODUCTSFROMAPI', value: null });
        // this.props.dispatch({ type: 'SELECTEDCATEGORYDESC', value: null });
        // this.props.dispatch({ type: 'PRODUCTBANNER', value: null });       
    }
    componentDidMount() {
        if(this.props.appState && this.props.appState.isMvaFlow){
            Utils.showHideNativeTitleBackBtn(this.props.appState.mvaType,this.props.appState.isMVAFiosEqipFlow, mvaNavigationPattern.patternB);
        }
        if(this.props.match.params.compatibility){
          let  filterConditions= {
                categoryId:this.props.productsState.pageinfo == null ?
                  this.props.categoriesState.categoryDetails.categoryName.categoryId.toString() : this.props.productsState.pageinfo.categoryId,
                  color: [],
                  brand: [],
                  compatibility: [this.props.match.params.compatibility],
                  price: ''
  
              }
              let request = filterConditions
            request['signedIn'] = this.props.categoriesState.isValidUser;
            request['mlpFlow'] = (this.props.appState && this.props.appState.mlpFlow) ? this.props.appState.mlpFlow : false;
            request['redemptionProductName'] = (this.props.appState && this.props.appState.mlpPDP) ? this.props.appState.mlpPDP : "";
            productsAction.setFilterData(this.props.dispatch, request)            
            productsAction.getProductsFromApi(JSON.stringify(request), this.props.dispatch, this.props.appState.visitId)

        }else if( (this.props.match.params.filter === "color" ||  this.props.match.params.filter === "Color") && 
                this.props.match.params.filterName){           
            let colorName = this.props.match.params.filterName;
            colorName = colorName.charAt(0).toUpperCase()+colorName.slice(1);
            let  filterConditions= {
                  categoryId:this.props.productsState.pageinfo == null ?
                    this.props.categoriesState.categoryDetails.categoryName.categoryId.toString() : this.props.productsState.pageinfo.categoryId,
                    color: [colorName],
                    brand: [],
                    compatibility: [],
                    price: ''
    
                }
                let request = filterConditions
              request['signedIn'] = this.props.categoriesState.isValidUser;
              request['mlpFlow'] = (this.props.appState && this.props.appState.mlpFlow) ? this.props.appState.mlpFlow : false;
              request['redemptionProductName'] = (this.props.appState && this.props.appState.mlpPDP) ? this.props.appState.mlpPDP : "";
              productsAction.setFilterData(this.props.dispatch, request)            
              productsAction.getProductsFromApi(JSON.stringify(request), this.props.dispatch, this.props.appState.visitId)
  
          }else if( (this.props.match.params.filter === "brand" ||  this.props.match.params.filter === "Brand") && 
                 this.props.match.params.filterName){
            let brand = this.props.match.params.filterName;
                brand = brand.charAt(0).toUpperCase()+brand.slice(1);
            let  filterConditions= {
                  categoryId:this.props.productsState.pageinfo == null ?
                    this.props.categoriesState.categoryDetails.categoryName.categoryId.toString() : this.props.productsState.pageinfo.categoryId,
                    color: [],
                    brand: [brand],
                    compatibility: [],
                    price: ''
    
                }
                let request = filterConditions
              request['signedIn'] = this.props.categoriesState.isValidUser;
              request['mlpFlow'] = (this.props.appState && this.props.appState.mlpFlow) ? this.props.appState.mlpFlow : false;
              request['redemptionProductName'] = (this.props.appState && this.props.appState.mlpPDP) ? this.props.appState.mlpPDP : "";
              productsAction.setFilterData(this.props.dispatch, request)            
              productsAction.getProductsFromApi(JSON.stringify(request), this.props.dispatch, this.props.appState.visitId)
  
          }
        else{
            this.getProducts()
        }
        checktime(this.callCheckTime('WillMount'));
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.pageName !== this.props.props.match.params.pageName) {
            this.getProducts()
        }
    }
    processPageAfterVisitID = () => {
        try {
            updatePageLogs(this.props.appState, this.props.appState.visitId, false);
            checktime(this.callCheckTime('Mount'));
            // getDTMInit("checkAvaillqInit", { appInfo: this.props.appState, lqInfo: this.props.lqState });
        }
        catch (ex) {
            catchJSException('visitId_Error', this.props.appState.visitId, 'processPageAfterVisitID', ex);
        }
    }
    callCheckTime = ((pagestate) => {
        return {
            page: 'Categoriespage',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })

    showCompatibilityProduct = () => {
        try {
            this.setState({
                showCompatibility: !this.state.showCompatibility
            })
        } catch (ex) {
            catchJSException('product_index', this.props.appState.visitId, 'showCompatibilityProduct', ex);
        }
    }
    showBrandProduct = () => {
        try {
            this.setState({
                showBrand: !this.state.showBrand
            })
        } catch (ex) {
            catchJSException('product_index', this.props.appState.visitId, 'showBrandProduct', ex);
        }
    }
    showColorProduct = () => {
        try {
            this.setState({
                showColor: !this.state.showColor
            })
        } catch (ex) {
            catchJSException('product_index', this.props.appState.visitId, 'showColorProduct', ex);
        }
    }
    handleOutsideClick(e) {
        try {
            if (this.node && this.node.contains(e.target)) {
                return;
            }
             this.handleClick();
        } catch (ex) {
            catchJSException('product_index', this.props.appState.visitId, 'handleOutsideClick', ex);
        }
    }
    handleClick(e,btnId) {
        try {
            if (!this.state.popupVisible) {
                if(btnId != 'sortBtn' ){
                   // e.preventDefault();
                   return;
                }
                document.addEventListener('click', this.handleOutsideClick, false);
            } else {
                document.removeEventListener('click', this.handleOutsideClick, false);
            }
            this.setState(prevState => ({
                popupVisible: !prevState.popupVisible,
            }));

        } catch (ex) {
            catchJSException('product_index', this.props.appState.visitId, 'handleClick', ex);
        }
    }
    sortByClick = (id) => {
        try {
            this.setState({
                sortBy: id,
                popupVisible: false
            })
            
            if (id === "Price Low - High") {
                document.getElementById("Price Low - High").className="active"
                document.getElementById("Price High - Low").className=""
                document.getElementById("Featured").className=""
          }
          else if (id === "Price High - Low") {
            document.getElementById("Price Low - High").className=""
            document.getElementById("Price High - Low").className="active"
            document.getElementById("Featured").className=""
          }
          else{
            document.getElementById("Price Low - High").className=""
            document.getElementById("Price High - Low").className=""
            document.getElementById("Featured").className="active"
          }
        } catch (ex) {
            catchJSException('product_index', this.props.appState.visitId, 'sortByClick', ex);
        }
    }
    handlePageNumber = (number) => {
        try {
            let currentPageNo = number;
            // let categoryId = this.props.categoriesState.categoryDetails? 
            // this.props.categoriesState.categoryDetails.categoryName.categoryId:this.props.productsState.pageinfo.categoryId;
            let categoryId = this.props.productsState.pageinfo.categoryId ? this.props.productsState.pageinfo.categoryId : "";
            let color = this.props.filterDataValue.color;
            let brand = this.props.filterDataValue.brand;
            let compatibility = this.props.filterDataValue.compatibility;
            let price = this.props.filterDataValue.price;
            let signedIn =  this.props.categoriesState.isValidUser;
            let request = {
                "categoryId": categoryId,
                "pageNo": currentPageNo,
                "color": color,
                "brand": brand,
                "compatibility": compatibility,
                "price": price,
                "signedIn":signedIn,
                "mlpFlow" : (this.props.appState && this.props.appState.mlpFlow) ? this.props.appState.mlpFlow : false,
                "redemptionProductName": (this.props.appState && this.props.appState.mlpPDP) ? this.props.appState.mlpPDP : ""
            }
            this.setState({ ...this.state.currentPage, currentPage: currentPageNo })
            productsAction.getProductsFromApi(JSON.stringify(request), this.props.dispatch, this.props.appState.visitId);

        } catch (ex) {
            catchJSException('product_index', this.props.appState.visitId, 'handlePageNumber', ex);
        }
    }
    showFilters = () => {
        if (!this.state.filterFlag) {
            this.setState({
                filterFlag: true,
                filterTag: "Hide filter "
            })
            productsAction.setFilterFlag(this.props.dispatch, true);    
        }
        else {
            this.setState({
                filterFlag: false,
                filterTag: "Show filter "
            })
            productsAction.setFilterFlag(this.props.dispatch, false);    
        }
    }




    render() {
        let browerUrl
        let metaInfoContent
        let titleTag
        let descriptionTags
        let keywords
        if(Utils.isMobileView() && this.state .filterFlag && (!this.props.filterFlag)){            
            this.setState({filterFlag:false});
        }
        if(this.props.location){
         browerUrl =  Utils.getDomainUrl()+this.props.location.pathname 
        }
        if(this.props.categoriesState&&this.props.categoriesState.categoriesExp){
        this.props.categoriesState.categoriesExp.map((category)=>{
            if(category.categoryId===this.props.productsState.pageinfo.categoryId){
               return(
                metaInfoContent= category.metaInfo,
                titleTag=category.titleTag,
                descriptionTags=category.descriptionTags,
                keywords=category.kws
               )
            } 
        })
    }
        
        let metaInfo
        if (metaInfoContent) {
            metaInfo = (
                <div >
                    <Helmet>
                    {ReactHtmlParser(metaInfoContent)}
                    <title>{ReactHtmlParser(titleTag)}</title> 
                    <meta name="description" content={descriptionTags}/>
                    <meta name="keywords" content={keywords}/>
                    </Helmet>
                </div>
            )
        }
        else{
            metaInfo = (
                <div >
                    <Helmet>
                    <link  rel="canonical" href={browerUrl}/>
                    </Helmet>
                </div>
            )
            
        }
        let product = <ProductsList productsValue={this.props.productsState.productsExp} props={this.props.props} categoriesState={this.props.categoriesState} productColor={this.props.productsState.filterData} clrFlag={this.state.clrFlag} paginationState={this.props.paginationState} />;
        let accessoriesHeader = <AccessoriesHeader accessoriesHeaderValue={this.props.categoriesState} props={this.props.props}></AccessoriesHeader>
        let faq = <Faq props={this.props} />
        let compatibilityResponse = this.props.productsState.filterExp && this.props.productsState.filterExp.compatibilityList
        let compatibilityList = compatibilityResponse === null ? <div></div> :
            <div >
                <div className={this.state.showCompatibility ? 'm_accordion-summary m_single plus' : 'm_accordion-summary m_single minus'}
                    onClick={this.showCompatibilityProduct}  tabIndex="0" onKeyPress={this.showCompatibilityProduct} role="button" aria-expanded={!this.state.showCompatibility}>  Compatibility </div>
                <Compatibility action={this.onFilterEvent} preSelection={this.onSearchValue} showCompatibility={this.state.showCompatibility}
                    compatibilityValue={this.props.filterState}></Compatibility>
            </div>
        let brandResponse = this.props.productsState.filterExp && this.props.productsState.filterExp.brandList
        let brandList = brandResponse === null ? <div></div> :
            <div>
                <div className={this.state.showBrand ? 'm_accordion-summary m_single plus' : 'm_accordion-summary m_single minus'}
                    onClick={this.showBrandProduct} onKeyPress={this.showBrandProduct} tabIndex="0" role="button" aria-expanded={!this.state.showBrand}> Brand </div>
                <Brand action={this.onFilterEvent} preSelection={this.onSearchValue} showBrand={this.state.showBrand} brandValue={this.props.filterState}></Brand>
            </div>
        const colorListResponse = this.props.productsState.filterExp && this.props.productsState.filterExp.colorList
        let colorList = colorListResponse === null ? "" :
            <div>
                <div className={this.state.showColor ? 'm_accordion-summary m_single plus' : 'm_accordion-summary m_single minus'}
                    onClick={this.showColorProduct} onKeyPress={this.showColorProduct} tabIndex="0" role="button" aria-expanded={!this.state.showColor}> Color </div>
                <Color action={this.onFilterEvent} preSelection={this.onSearchValue} showColor={this.state.showColor} colorValue={this.props.filterState}></Color>
            </div>
        //let productName = Utils.isNotNull(this.props.productsState && this.props.productsState.productsExp && this.props.productsState.productsExp.groupName) ? this.props.productsState.productsExp.groupName : ""
        let productName = Utils.isNotNull(this.props.selectedCategoryState && this.props.selectedCategoryState.groupName) ? this.props.selectedCategoryState.groupName : ""
        //let productDescription = Utils.isNotNull(this.props.productsState && this.props.productsState.productsExp && this.props.productsState.productsExp.groupDescription) ? this.props.productsState.productsExp.groupDescription : ""
        // let productDescription = Utils.isNotNull(this.props.selectedCategoryState && this.props.selectedCategoryState.groupDesc) ? ReactHtmlParser(this.props.selectedCategoryState.groupDesc) : ""
        let productDescription;
        if(this.props.categoriesState.isSignApplied){
            if(this.props.selectedCategoryState && this.props.selectedCategoryState.groupDesc && this.props.selectedCategoryState.groupDesc.includes('<b>Sign in to see any possible additional discounts</b>')){
                let filterGroupDesc = this.props.selectedCategoryState.groupDesc.replace('<b>Sign in to see any possible additional discounts</b>', '');
                productDescription = Utils.isNotNull(this.props.selectedCategoryState && this.props.selectedCategoryState.groupDesc) ? ReactHtmlParser(filterGroupDesc) : "";
            }
        }else{
            productDescription = Utils.isNotNull(this.props.selectedCategoryState && this.props.selectedCategoryState.groupDesc) ? ReactHtmlParser(this.props.selectedCategoryState.groupDesc) : ""
        }
        let footerDescription = Utils.isNotNull(this.props.selectedCategoryState && this.props.selectedCategoryState.footerDescription) ? (this.props.selectedCategoryState.footerDescription) : ""
        //let totalProducts = Utils.isNotNull(this.props.productsState && this.props.productsState.productsExp && this.props.productsState.productsExp.products) ? this.props.productsState.productsExp.products.length : ""
        let totalProducts = Utils.isNotNull(this.props.paginationState && this.props.paginationState.productCount) ? this.props.paginationState.productCount : ''
        let minProdCount = Utils.isNotNull(this.props.paginationState && this.props.paginationState.minProdCount) ? this.props.paginationState.minProdCount : ''
        let maxProdCount = Utils.isNotNull(this.props.paginationState && this.props.paginationState.maxProdCount) ? this.props.paginationState.maxProdCount : ''
        let showingContent = Utils.isNotNull(this.props.paginationState && this.props.paginationState.pagination) ? this.props.paginationState.pagination ?
            <span>
                <span className="normal-weight" id="paginationProdCount"><b>{minProdCount} - {maxProdCount}</b> out of </span>{totalProducts} <span className="normal-weight">products</span>
            </span>
            : <span>
                <span className="normal-weight" id="paginationProdCount"> </span> {totalProducts} <span className="normal-weight">products</span>
            </span> : ""


        let currentPageNo = (minProdCount === 1) ? 1 : this.state.currentPage;

        let pagenumber;
        if (Utils.isNotNull(this.props.paginationState)) {
            this.setState({
                paginationState: this.props.paginationState,

            })
            if (this.state.paginationState) {
                let pgNumber = [];
                let totalPageCount = this.state.paginationState.totalPageCount;
                for (let i = 1; i <= totalPageCount; i++) {
                    pgNumber.push(i);
                }
                const renderPageNumbers = pgNumber.map(number => {
                    return (
                        <div className={currentPageNo === number ? 'pagination_item active' : 'pagination_item'}>
                            <a aria-current={(currentPageNo === number) ? "page" : ""} tabIndex="0" role='link' aria-label={"Page" + number + "of" + totalPageCount + this.props.productsState.pageinfo.categoryName} key={number} id={number} onClick={() => this.handlePageNumber(number)} onKeyPress={() => this.handlePageNumber(number)}>
                                {number}
                            </a>
                        </div>
                    );
                });
                pagenumber = this.state.paginationState.pagination ? <div className="w_pagination clear" >
                    <div  className="pagination_item m_prev" disabled={currentPageNo === 1 ? 'disabled' : ''} title="previous">
                        <a aria-label="previous page" role='link' tabIndex={currentPageNo === 1 ? "-1" : "0"} onClick={() => { if (currentPageNo > 1) this.handlePageNumber(currentPageNo - 1) }} onKeyPress={() => { if (currentPageNo > 1) this.handlePageNumber(currentPageNo - 1) }}> </a>
                    </div>
                    {renderPageNumbers}
                    <div  className="pagination_item m_next" disabled={currentPageNo === totalPageCount ? 'disabled' : ''} title="next">
                        <a  aria-label="next page" role='link' tabIndex={currentPageNo === totalPageCount ? "-1" : "0"} onClick={() => { if (currentPageNo < totalPageCount) this.handlePageNumber(currentPageNo + 1) }} onKeyPress={() => { if (currentPageNo < totalPageCount) this.handlePageNumber(currentPageNo + 1) }}> </a>
                    </div>
                </div> : ""
            }
        }
        let prdBanner;
        const options = {
            decodeEntities: true,
            transform
        };
        function transform(node, index) {
            if (node.type === 'tag' && node.name === 'img') {
                let path = node.attribs.src;
                node.attribs.style = "width:430px; height:auto"
                node.attribs.src = Utils.getImagePath(path);
                return convertNodeToElement(node, index, transform);
            }
            else if (node.type === 'tag' && node.name === 'div' && node.attribs.class==="left padding-left-medium tiny-p-70 medium-p-70 large-p-80") {
                node.attribs.class = "left padding-left-medium tiny-p-60 medium-p-70 large-p-80"
                return convertNodeToElement(node, index, transform);
            } else if (node.type === 'tag' && node.name === 'h5' && node.attribs.class === "margin-bottom-micro margin-top-zero"){
                node.name = "h2";                
                let deviceType = Utils.isMobileView();
                if(deviceType){
                    node.attribs.style = "color : #fff ; font-size : 1.125rem ; line-height : 1.125rem";
                } else {
                    node.attribs.style = "color : #fff ; font-size : 1.5rem ; line-height : 1.875rem";
                }
            }
        }
        /**filter allignment fix :CETC-140679*/
        let hideFilterStyle = {
            top: '13.8rem'
        }
        let categoryName = this.props.categoriesState.categoryDetails? 
        this.props.categoriesState.categoryDetails.categoryName.name : this.props.productsState.pageinfo.categoryName;

        if(categoryName == "Streaming TV Devices" || categoryName == "All accessories"){
            hideFilterStyle = {
                top: '16.5rem'
            }
        }
        if(categoryName == "Smart home" || categoryName == "Audio" || categoryName == "Smart security devices"){
            hideFilterStyle = {
                top: '14.4rem'
            }
        }
        if(categoryName == "Phone equipment" || categoryName == "Clearance"){
            hideFilterStyle = {
                top: '12rem'
            }
        }

        // console.log(this.props.productsState.prodBanner)
        if (Utils.isNotNull(this.props.productsState && this.props.productsState.prodBanner)) {

            prdBanner = (
                <div className="w_promo-section">
                    {ReactHtmlParser(this.props.productsState.prodBanner.description, options)}
                </div>
            )
        }

        return (
            <div>
                {metaInfo}
                {accessoriesHeader}
                <div class="w_filter-mobile" >
                    <div style={{ height: "507.2px" }} data-subfilter="">
                        <div class="left">
                            <div className=" bold">
                                {showingContent}
                            </div>
                        </div>
                        <div class="right">
                            <a onClick={this.showFilters} className="bold" role="button" tabindex="0" aria-expanded={this.state.filterFlag}>{this.state.filterTag}</a>
                        </div>
                        <div style={{ transition: "opacity 300ms ease 0s" }} className={"filter-mobile_category clear " + (this.state.filterFlag ? "" : "hide")} data-reveal-content="filterContent">
                            <div class="filter-sub-category" id="filter-category-mobile">
                                <div>
                                    {compatibilityList}
                                </div>
                                <div>
                                    {brandList}
                                </div>
                                <div>
                                    {colorList}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <main className="main">
                    <Loader />
                    <div className="w_hero-banner">
                        <div className="row medium-vert-bottom">
                            {faq}
                            <div className="column medium">
                                <h1 className="hero-banner_title float-reset margin-all-zero line-height-medium" data-banner-title="">
                                    {productName}
                                </h1>
                                <p className="hero-banner_description">
                                    {productDescription}
                                </p>
                                <div className="filter-result bold show-for-small-up">Showing {showingContent} </div>
                            </div>
                            <div className="column hero-banner_sort medium-vert-bottom padding-vert-zero">
                                <div className="w_toolbar border-all-none">
                                    <input type="hidden" id="sortUrl" value="/home/accessories/networking-wifi/?" className="value" aria-required="false" />
                                    <div className="toolbar_product hide">
                                        <span className="toolbar_product-count">{totalProducts}</span> Products
                                    </div>
                                    {/* <button class="button secondary added-filter show-for-small-up" data-add-filter="" aria-expanded={this.state.filterFlag} tabindex="0" onClick={this.showFilters} style={this.state.filterTag==="Hide filter" ? {position:"relative",top:"11.3rem"}: {}}>{this.state.filterTag}</button> */}
                                    <div role="button"  id="show-filter" class="button secondary added-filter show-for-small-up" data-add-filter="" aria-expanded={this.state.filterFlag} tabindex="0" onKeyPress={this.showFilters} onClick={this.showFilters} style={this.state.filterTag==="Hide filter" ? {position:"relative",top:"11.3rem"}: {}}>{this.state.filterTag}</div>
                                    {/* <p id="showing-products"  class="sr-only" role='alert' aria-label={  Utils.isNotNull(this.props.paginationState && this.props.paginationState.pagination) ? this.props.paginationState.pagination ? 'Showing' + minProdCount + '-' + maxProdCount + ' out of' + totalProducts + ' products' : 'Showing' + totalProducts + ' products':""} ></p> */}
  
                                    <p id="showing-products" class="sr-only"  aria-label={(this.state.paginationState && this.state.paginationState.pagination ) ?  'Showing' + minProdCount + '-' + maxProdCount + ' out of' + totalProducts + ' products' : 'Showing' + totalProducts + ' products'} ></p>
                                    {/* <div className={"w_filter " + (this.state.filterFlag ? "" : "hide")}> */}
                                    <div className={"w_filter " + (this.state.filterFlag ? "" : "hide")} style={hideFilterStyle}>
                                    <div style={{ height: "859.2px" }} data-subfilter="">
                                    <div className="filter-sub-category" id="filter-category">
                                        <div className="filter-wrapper">
                                         {compatibilityList}
                                        </div>
                                        <div className="filter-wrapper">
                                        {brandList}
                                        </div>
                                        <div className={colorList ? "filter-wrapper" : ""}>
                                         {colorList}
                                        </div>       
                                        <div className="clear"></div>
                                    </div>
                                  </div>
                                </div>
                                    <div className="w_select-box right m_select-box-sort" data-dropdown-container="" ref={node => { this.node = node; }}>
                                        <button className="select-box_selected m_sort-prefix" onClick={(e) => this.handleClick(e,'sortBtn')} aria-expanded={this.state.popupVisible}>
                                            <span>{this.state.sortBy}</span>
                                        </button>
                                        <ul className="select-box_options" id="sortButton" data-dropdown-options="" data-option-categories="" style={{ width: '250px', display: this.state.popupVisible ? 'block' : 'none' }}>
                                            <li lid="sort: Featured" id="Featured" onClick={() => {
                                                updateSCTags("sort: featured");
                                                this.sortByClick("Featured");
                                                this.onFilterEvent("price", "Featured")
                                            }} onKeyPress={() => {
                                                updateSCTags("sort: featured");
                                                this.sortByClick("Featured");
                                                this.onFilterEvent("price", "Featured")
                                            }} className="" tabIndex="0" role="link">Featured</li>
                                            <li lid="sort: Price Low - High" id="Price Low - High"
                                                onClick={() => { updateSCTags("sort: price low"); this.sortByClick("Price Low - High"); this.onFilterEvent("price", "LowHigh") }}
                                                onKeyPress={() => { updateSCTags("sort: price low"); this.sortByClick("Price Low - High"); this.onFilterEvent("price", "LowHigh") }}
                                                className="" tabIndex="0" role="link">Price Low - High</li>
                                            <li lid="sort: Price High - Low" id="Price High - Low"
                                                onClick={() => {
                                                    updateSCTags("sort: price high");
                                                    this.sortByClick("Price High - Low");
                                                    this.onFilterEvent("price", "HighLow")
                                                }} 
                                                onKeyPress={() => {
                                                    updateSCTags("sort: price high");
                                                    this.sortByClick("Price High - Low");
                                                    this.onFilterEvent("price", "HighLow")
                                                }}className="" tabIndex="0" role="link">Price High - Low</li>
                                        </ul>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="accessories-result">
                        {prdBanner}

                        {product}

                    </div>
                    {pagenumber}
                    <div className="products-description_container" >
                        {ReactHtmlParser(footerDescription)}
                    </div>
                </main>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        productsState: state.productsVTP,
        faqState: state.faqDetailsVTP,
        categoriesState: state.categoriesVTP,
        filterState: state.productsVTP.filterExp,
        filterDataValue: state.productsVTP.filterData,
        paginationState: state.productsVTP.paginationExp,
        appState: state.appVTP,
        selectedCategoryState: state.productsVTP.selectedCategoryDescExp,
        filterFlag:state.productsVTP.filterFlag
    }
}
export default withRouter(connect(mapStateToProps)(Product));
